// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { AISLE, AISLE_AND_WINDOW } from '../../constants/seatColumnTypes';
const checkRowCharacteristics = (row, characteristic) => {
  var _row$characteristics;
  return (_row$characteristics = row.characteristics) === null || _row$characteristics === void 0 ? void 0 : _row$characteristics.some(rowCharacteristic => rowCharacteristic === characteristic);
};
export const isExitRow = row => checkRowCharacteristics(row, 'EXIT_ROW');
export const isEmptyRow = row => checkRowCharacteristics(row, 'EMPTY_ROW');
export const isRowOverWing = row => checkRowCharacteristics(row, 'OVER_WING_ROW');
const hasAisleGapBetween = (previousColumn, currentColumn) => {
  const eitherIsAisleAndWindow = previousColumn.type === AISLE_AND_WINDOW || currentColumn.type === AISLE_AND_WINDOW;
  const bothAreAisles = previousColumn.type === AISLE && currentColumn.type === AISLE;
  return eitherIsAisleAndWindow || bothAreAisles;
};
const AISLE_GAP_COLUMN = {
  columnName: null,
  type: 'EMPTY'
};
const hasColumn = seat => seat.column != null;

/**
 * Keeps the first seat seen for each column, so the column order of the rows decides which seat
 * describes the column. Callers rely on this happening before any sorting.
 */
const firstSeatPerColumn = seats => {
  const byColumn = new Map();
  seats.forEach(seat => {
    if (!byColumn.has(seat.column)) {
      byColumn.set(seat.column, seat);
    }
  });
  return [...byColumn.values()];
};
export const deriveColumnDetailsFromRows = rows => firstSeatPerColumn(rows.flatMap(row => {
  var _row$sellSeatMapSeats;
  return (_row$sellSeatMapSeats = row.sellSeatMapSeats) !== null && _row$sellSeatMapSeats !== void 0 ? _row$sellSeatMapSeats : [];
}).filter(hasColumn)).sort((a, b) => a.column.localeCompare(b.column)).map(({
  column,
  type
}) => ({
  columnName: column,
  type: type !== null && type !== void 0 ? type : null
}));
export const insertAisleGapColumns = columns => columns.reduce((columnsWithGaps, column, index) => {
  if (index > 0 && hasAisleGapBetween(columns[index - 1], column)) {
    columnsWithGaps.push(AISLE_GAP_COLUMN);
  }
  columnsWithGaps.push(column);
  return columnsWithGaps;
}, []);
const createMissingSeatPlaceholder = (rowNumber, columnName) => ({
  column: columnName,
  isBookable: false,
  mainCharacteristic: null,
  row: rowNumber,
  seat: String(rowNumber !== null && rowNumber !== void 0 ? rowNumber : '') + columnName,
  type: 'EMPTY',
  characteristics: []
});
const createAisleGapSeat = ({
  rowNumber
}) => ({
  column: null,
  row: rowNumber,
  type: AISLE,
  characteristics: []
});
const findOrCreateSeatForColumn = (row, column) => {
  const existingSeat = row.sellSeatMapSeats.find(seat => seat.column === column.columnName);
  return existingSeat || createMissingSeatPlaceholder(row.rowNumber, column.columnName);
};
export const addAislesToRows = (cabinRows, columnDetails) => {
  return cabinRows.map(row => {
    const rowSeats = columnDetails.reduce((seatsSoFar, column) => {
      var _row$sellSeatMapSeats2;
      const safeRow = {
        sellSeatMapSeats: (_row$sellSeatMapSeats2 = row.sellSeatMapSeats) !== null && _row$sellSeatMapSeats2 !== void 0 ? _row$sellSeatMapSeats2 : [],
        rowNumber: row.rowNumber
      };
      if (column.type === 'EMPTY') {
        seatsSoFar.push(createAisleGapSeat(safeRow));
      } else if (column.columnName != null) {
        seatsSoFar.push(findOrCreateSeatForColumn(safeRow, {
          columnName: column.columnName
        }));
      }
      return seatsSoFar;
    }, []);
    return {
      ...row,
      sellSeatMapSeats: rowSeats
    };
  });
};
const addExplicitEmptyRow = row => {
  const emptyRowLayout = (row.sellSeatMapSeats || []).map((seat, index, arr) => {
    if (index === 0 || index === arr.length - 1) {
      return {
        column: seat === null || seat === void 0 ? void 0 : seat.column,
        type: 'EXIT_ARROW'
      };
    }
    return {
      column: seat === null || seat === void 0 ? void 0 : seat.column
    };
  });
  return {
    characteristics: ['EMPTY_ROW', ...(isRowOverWing(row) ? ['OVER_WING_ROW'] : [])],
    rowNumber: null,
    sellSeatMapSeats: emptyRowLayout
  };
};
export const addExitRows = cabinRows => {
  if (!cabinRows) {
    return null;
  }
  return cabinRows.reduce((rowsSoFar, row) => {
    if (checkRowCharacteristics(row, 'EXIT_ROW')) {
      return [...rowsSoFar, addExplicitEmptyRow(row), row];
    }
    return [...rowsSoFar, row];
  }, []);
};
//# sourceMappingURL=SeatMapCabin.utils.js.map